import React, { useEffect, useState } from 'react';
import { PHONE_QUERY, pickView } from './device';

const isPhoneNow = () => typeof window !== 'undefined' && !!window.matchMedia?.(PHONE_QUERY).matches;

/** Follows the phone media query, so rotating or resizing swaps the design. */
export const useIsPhone = () => {
  const [phone, setPhone] = useState(isPhoneNow);
  useEffect(() => {
    const mq = window.matchMedia?.(PHONE_QUERY);
    if (!mq) return;
    const onChange = () => setPhone(mq.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);
  return phone;
};

export const ByDevice: React.FC<{
  desktop: React.ComponentType;
  mobiles: Record<string, React.ComponentType>;
  fallback: string;
}> = ({ desktop: Desktop, mobiles, fallback }) => {
  const phone = useIsPhone();
  const view = pickView(window.location.search, phone, Object.keys(mobiles), fallback);
  if (view.kind === 'desktop') return <Desktop />;
  const Mobile = mobiles[view.id];
  return (
    <div data-mobile={view.id}>
      <Mobile />
    </div>
  );
};
